import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, ɵɵresolveBody } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { Reportes } from '@pages/cobranza/interfaces/reportes';



const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({
  providedIn: 'root'
})

export class ReporteService {

  private _url = environment.apiBaseUrl + 'api/Reportes';

  constructor(private _http: HttpClient) { }

  getAllReports(model: Reportes): Observable<Reportes> {

    return this._http.post<Reportes>(this._url, model, httpOption);

  }

}